import { COMPANY_ID } from "app/utils/constant";
import axiosInstance from "./axiosInstance";

// for enrolled events
export const enrolledEvents = async (payload) => {
  const {
    search,
    filterBy,
    page,
    limit,
    status,
    user_id,
    visibility_for,
    event_visibility,
  } = payload;

  try {
    const res = await axiosInstance.get(
      `/events?page=${page}&limit=${limit}&${filterBy}=${search}&status=${status}&user_id=${user_id}&visibility_for=${visibility_for}&event_visibility=${event_visibility}&platform=web`,
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

// for my order/purchases
export const myOrders = async (payload) => {
  // const { search, filterBy, page, limit, status, user_id } = payload;
  const { search, filterBy, user_id } = payload;

  try {
    const res = await axiosInstance.get(
      `/users/${user_id}/orders?${filterBy}=${search}`,
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

// for my events
export const myEvents = async (payload) => {
  const {
    search,
    filterBy,
    page,
    limit,
    status,
    host_id,
    visibility_for,
    event_visibility,
  } = payload;

  try {
    const res = await axiosInstance.get(
      `/events?page=${page}&limit=${limit}&${filterBy}=${search}&status=${status}&host_id=${host_id}&visibility_for=${visibility_for}&event_visibility=${event_visibility}&platform=web`,
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

//  for checking convener / member
export const checkingUserRole = async (userId) => {
  try {
    const res = await axiosInstance.get(
      `/events?host_id=${userId}&platform=web`,
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

export const listEvents = async (payload) => {
  const {
    search,
    filterBy,
    page,
    limit,
    status,
    companyId,
    eventCategory,
    categoryValue,
    isVisible,
    visibility_for,
    event_visibility,
  } = payload;

  try {
    const res = await axiosInstance.get(
      `/events?page=${page}&limit=${limit}&${filterBy}=${search}&status=${status}&company_id=${companyId}&platform=web&${eventCategory}=${categoryValue}&is_visible=${isVisible}&visibility_for=${visibility_for}&event_visibility=${event_visibility}`,
      {
        headers: {
          "x-skip-auth": "true",
        },
        metadata: { isPublic: true },
      },
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

export const viewEvent = async (eventId, payload = {}) => {
  try {
    const params = new URLSearchParams();
    if (payload.include) params.append("include", payload.include); // include = images => for getting all the event images together
    const res = await axiosInstance.get(
      `/events/${eventId}?${params.toString()}`,
      {
        headers: {
          "x-skip-auth": "true",
        },
        metadata: { isPublic: true },
      },
    );

    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return null;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { status: 503, message: "Service Unavailable" };
    } else {
      return { status: 500, message: error.message };
    }
  }
};

// Approve Event by id
export const eventApproval = async (payload) => {
  const eventId = payload.eventId;
  const status = payload.status;
  const body = payload.body;

  try {
    const res = await axiosInstance.patch(
      `/events/${eventId}?action=${status}`,
      body,
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

// cancel event by id
export const cancelEvent = async (eventId) => {
  try {
    const res = await axiosInstance.delete(`/events/${eventId}`);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    return error.response;
  }
};

//

export const eventEditAPI = async (id, data) => {
  try {
    const res = await axiosInstance.put(`/events/${id}`, data);
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

export const createEventAPI = async (data) => {
  try {
    const res = await axiosInstance.post(`/events`, data);
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

// attendees by event + payment status

export const listAttendeesByEvent = async (payload) => {
  const limit = payload.limit;
  const eventId = payload.eventId;

  try {
    const res = await axiosInstance.get(
      `events/${eventId}/payment-details?page=1&limit=${limit}`,
    );
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      return;
    }
  } catch (error) {
    return error?.response;
  }
};

export const listCategories = async () => {
  try {
    const res = await axiosInstance.get(`/categories`);
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch product categories!");
    }
  } catch (error) {
    console.error("error", error);
    return error?.response;
  }
};

// pending transaction list
export const pendingTransactionApi = async ({
  id,
  page,
  payment_status,
  user_name,
}) => {
  try {
    const res = await axiosInstance.get(
      `/events/${id}/payment-details?page=${page}&limit=10&payment_status=${payment_status}&user_name=${user_name}&review=true`,
    );
    if (res.status === 200 || res.status === 201) {
      return res.data;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

export const eventImageUpload = async (payload) => {
  const file = payload?.file;
  const type = payload?.type;

  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);

    const res = await axiosInstance.post(`/file-upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

// approval Reject api for payment
export const approvalRejectApi = async ({ id, body }) => {
  try {
    const res = await axiosInstance.post(`/events/${id}/review-payment`, body);
    if (res.status === 200 || res.status === 201) {
      return res.data;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

// Import users from CSV
export const importUsersFromCSV = async (
  eventId,
  csvFile,
  importConfirmed = false,
) => {
  try {
    const formData = new FormData();
    formData.append("csv_file", csvFile);

    const res = await axiosInstance.post(
      `/events/${eventId}/payments/csv?import_confirmed=${importConfirmed}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return res;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return {
        status: 503,
        data: {
          error: {
            msg: "Service Unavailable - No response from server",
          },
        },
      };
    } else {
      return {
        status: 500,
        data: {
          error: {
            msg: error.message || "Request failed",
          },
        },
      };
    }
  }
};

// Get bulk registration guidelines
export const getBulkRegistrationGuidelines = async (eventId) => {
  try {
    const res = await axiosInstance.get(
      `/events/${eventId}/payment/csv/guidelines`,
    );
    if (res.status === 200 || res.status === 201) {
      return res.data;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

// Download CSV template for bulk registration
export const downloadCSVTemplate = async (eventId) => {
  try {
    const res = await axiosInstance.get(
      `/events/${eventId}/payments/csv/template`,
      {
        responseType: "blob", // Important for file download
      },
    );

    // Since it's a blob response, we need to check if it's an error or the actual file
    if (res.status === 200 || res.status === 201) {
      // Check if the response is JSON (error) or CSV (success)
      const contentType = res.headers["content-type"];

      if (contentType && contentType.includes("application/json")) {
        // This is an error response
        const errorData = await new Response(res.data).json();
        return {
          status: "error",
          data: errorData,
          isBlob: false,
        };
      }

      // This is the actual CSV file
      return {
        status: "success",
        data: res.data,
        headers: res.headers,
        isBlob: true,
      };
    } else {
      return {
        status: "error",
        message: "Failed to download template",
        data: null,
        isBlob: false,
      };
    }
  } catch (error) {
    if (error.response) {
      return {
        status: "error",
        data: error.response.data,
        statusCode: error.response.status,
        isBlob: false,
      };
    } else if (error.request) {
      return {
        status: "error",
        message: "Service Unavailable - No response from server",
        isBlob: false,
      };
    } else {
      return {
        status: "error",
        message: error.message || "Request failed",
        isBlob: false,
      };
    }
  }
};

export const exportUsersByPaymentStatus = async (payload) => {
  const eventId = payload.eventId;
  const status = payload?.status;

  try {
    const res = await axiosInstance.get(
      `/events/${eventId}/payments/csv?status=${status}`,
    );
    if (res.status === 200 || res.status === 201) {
      return res.data;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

export const exportTabWiseReports = async (eventId) => {
  return axiosInstance.get(
    `/events/${eventId}/reports/table-wise-excel`,
    { responseType: "blob" }
  );
};

// event Summary

export const eventSummary = async (id) => {
  try {
    const res = await axiosInstance.get(`events/${id}/summary`);
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      return;
    }
  } catch (error) {
    return error?.response;
  }
};

// event registration by making payment

export const createPayment = async (data) => {
  const event_id = data?.eventId;
  const payload = {
    userId: data?.userId,
    transactionId: data?.transactionId,
  };

  try {
    const res = await axiosInstance.post(
      `/events/${event_id}/payment`,
      payload,
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

// Register Member to an event

export const registerMemberToAnEvent = async (data) => {
  const event_id = data?.eventId;
  const payload = data?.payload;

  try {
    const res = await axiosInstance.post(
      `/events/${event_id}/registrations`,
      payload,
      {
        headers: {
          "x-user-id": payload?.user_id,
          "x-organisation-id": COMPANY_ID,
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
      },
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

// update registration
export const updateRegistration = async (data) => {
  const event_id = data?.eventId;
  const user_id = data?.userId;
  const payload = data?.payload;

  try {
    const res = await axiosInstance.patch(
      `/events/${event_id}/users/${user_id}/purchases`,
      payload,
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    return error.response;
  }
};

// register public member to an event
export const registerPublicMemberToAnEvent = async (data) => {
  const event_id = data?.eventId;
  const payload = data?.payload;

  try {
    const res = await axiosInstance.post(
      `/events/${event_id}/purchases`,
      payload,
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

//QR image upload
export const QRImageUpload = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", "QRcodes");

    const res = await axiosInstance.post(`/file-upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

// bank detail
export const eventBankDetails = async (id) => {
  try {
    const res = await axiosInstance.get(`events/${id}/payments`);
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      return;
    }
  } catch (error) {
    return error?.response;
  }
};

// contact support
export const contactSupport = async (data) => {
  const user_id = data?.userId;
  const payload = data?.payload;
  try {
    const res = await axiosInstance.post(
      `/users/${user_id}/contact-support`,
      payload,
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return error.request;
    } else {
      return error.message;
    }
  }
};

export const eventReports = async (
  id,
  page,
  limit,
  sort,
  order,
  search,
  registrationFilter,
  paymentStatusFilterValue,
  statusFilter,
  tableFilter,
  roomTypeFilter,
  memberTypeFilterValue,
  areaFilter,
  hotelFilter,
  paymentMethodFilter,
) => {
  try {
    // Build query parameters
    const params = {
      page,
      limit,
      sort,
      order,
    };

    // Add search parameter if provided
    if (search) {
      params.name = search;
    }

    // Add table filter if not "all"
    if (tableFilter && tableFilter !== "all") {
      params.table_id = tableFilter;
    }

    // Add room type filter if not "all"
    if (roomTypeFilter && roomTypeFilter !== "all") {
      params.room_type = roomTypeFilter;
    }

    // Add registration filter if not "all"
    if (registrationFilter && registrationFilter !== "all") {
      params.registered = registrationFilter === "true";
    }

    // Add payment status filter if not "all"
    if (paymentStatusFilterValue && paymentStatusFilterValue !== "all") {
      params.payment_status = paymentStatusFilterValue;
    }

    // Add status filter if needed (for payment status)
    if (statusFilter && statusFilter !== "all") {
      params.status = statusFilter;
    }

    // Add member type filter - only pass guest_type when "guest" is selected
    if (memberTypeFilterValue && memberTypeFilterValue === "guest") {
      params.guest_type = "guest";
    }
    // For tabler and squareleg, you might want to use member_type parameter
    else if (memberTypeFilterValue && memberTypeFilterValue !== "all") {
      params.member_type = memberTypeFilterValue === "tabler" ? 1 : 2;
    }

    // Add area filter if not empty
    if (areaFilter && areaFilter !== "") {
      params.area_id = areaFilter;
    }

    // FIX: Handle hotel filter properly - check for product_id and convert to product_name if needed
    if (hotelFilter && hotelFilter !== "" && hotelFilter !== "all") {
      // If hotelFilter is a product_id, we need to get the product_name
      // For now, pass it as product_name (the API expects product_name)
      params.product_name = hotelFilter;
    }

    // Add payment method filter if not "all"
    if (paymentMethodFilter && paymentMethodFilter !== "all") {
      params.payment_method = paymentMethodFilter;
    }

    const res = await axiosInstance.get(`events/${id}/user-reports`, {
      params,
    });

    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return;
    }
  } catch (error) {
    return error?.response;
  }
};

export const getEventMembers = async (payload) => {
  const {
    id,
    page,
    limit,
    sort,
    order,
    search,
    user_type,
    member_type,
    shipment_status,
    product_name,
    product_id,
    variation_id,
    registered,
    payment_status,
    registration_type,
    payment_method,
  } = payload;

  try {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (limit) params.append("limit", limit);
    if (sort) params.append("sort", sort);
    if (order) params.append("order", order);
    if (user_type) params.append("user_type", user_type);
    if (member_type) params.append("member_type", member_type);
    if (shipment_status) params.append("shipment_status", shipment_status);

    if (registered !== undefined && registered !== "") {
      params.append("registered", registered);
    }
    if (payment_status && payment_status !== "") {
      params.append("payment_status", payment_status);
    }
    if (registration_type && registration_type !== "") {
      params.append("registration_type", registration_type);
    }
    if (payment_method && payment_method !== "") {
      params.append("payment_method", payment_method);
    }

    // ADD HOTEL FILTER
    if (product_name && product_name !== "" && product_name !== "all") {
      params.append("hotel_name", product_name);
    }

    if (product_id && product_id !== "" && product_id !== "all") {
      params.append("product_id", product_id);
    }

    if (variation_id && variation_id !== "") {
      params.append("variation_id", variation_id);
    }

    if (search) {
      const digitsOnly = search.replace(/\D/g, "");

      const isPhoneSearch = /^\d/.test(search);

      if (isPhoneSearch) {
        params.append("phone_number", digitsOnly);
      } else {
        params.append("name", search);
      }
    }

    const res = await axiosInstance.get(
      `/events/${id}/charity-event-users?${params.toString()}`,
    );

    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return null;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { status: 503, message: "Service Unavailable" };
    } else {
      return { status: 500, message: error.message };
    }
  }
};

// Event summary by event type
export const eventSummaryByType = async (id, eventType) => {
  try {
    const res = await axiosInstance.get(
      `/events/${id}/summary?event_type=${eventType}`,

      {
        headers: {
          // "x-user-id": payload?.user_id,
          "x-skip-auth": "true",
          "x-organisation-id": COMPANY_ID,
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
        metadata: { isPublic: true },
      },
    );
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      return null;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { status: 503, message: "Service Unavailable" };
    } else {
      return { status: 500, message: error.message };
    }
  }
};

export const eventUserReports = async (eventId, payload = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("page", payload.page || 1);
    params.append("limit", payload.limit || 10);
    if (payload.search) params.append("name", payload.search);
    if (payload.table_id) params.append("table_id", payload.table_id);
    if (payload.area_id) params.append("area_id", payload.area_id);
    if (payload.registered !== undefined)
      params.append("registered", payload.registered);
    if (payload.product_name) params.append("hotel_name", payload.product_name);
    if (payload.member_type !== undefined)
      params.append("member_type", payload.member_type);
    if (payload.sort) params.append("sort", payload.sort);
    if (payload.order) params.append("order", payload.order);

    const res = await axiosInstance.get(
      `/events/${eventId}/user-reports?${params.toString()}`,
    );

    if (res.status === 200 || res.status === 201) {
      return {
        status: "success",
        data: res.data.data,
        meta_data: res.data.meta_data || {
          total: res.data.total || 0,
          per_page: payload.limit || 10,
          current_page: payload.page || 1,
        },
      };
    }

    return {
      status: "error",
      message: res.data?.message || "Unexpected response",
      data: null,
      meta_data: null,
    };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || error.message,
      data: null,
      meta_data: null,
    };
  }
};

export const getEventHotelReports = async (eventId, payload = {}) => {
  try {
    const params = new URLSearchParams();

    params.append("page", payload.page || 1);
    params.append("limit", payload.limit || 20);

    if (payload.search) params.append("name", payload.search);
    if (payload.sort) params.append("sort", payload.sort);
    if (payload.order) params.append("order", payload.order);
    if (payload.table_id) params.append("table_id", payload.table_id);
    if (payload.payment_status)
      params.append("payment_status", payload.payment_status);
    if (payload.room_allocation_status)
      params.append("room_allocation_status", payload.room_allocation_status);
    if (payload.roomType) params.append("room_type", payload.roomType);
    if (payload.area_id) params.append("area_id", payload.area_id);
    if (payload.bookingStatus)
      params.append("booking_status", payload.bookingStatus);
    if (payload.checkedIn !== undefined)
      params.append("checked_in", payload.checkedIn);
    if (payload.product_name)
      params.append("product_name", payload.product_name);

    const res = await axiosInstance.get(
      `/events/${eventId}/hotel-reports?${params.toString()}`,
    );

    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return {
        status: "error",
        message: res.data?.message || "Failed to fetch hotel reports",
        data: null,
        metadata: null,
      };
    }
  } catch (error) {
    if (error.response) {
      return {
        status: "error",
        message: error.response.data?.message || "API Error",
        data: null,
        meta_data: null,
      };
    } else if (error.request) {
      return {
        status: "error",
        message: "No response received from server",
        data: null,
        meta_data: null,
      };
    } else {
      return {
        status: "error",
        message: error.message,
        data: null,
        meta_data: null,
      };
    }
  }
};

// Send reminder for an invoice
export const sendInvoiceReminder = async (invoice_id) => {
  try {
    const res = await axiosInstance.post(
      `/invoices/${invoice_id}/send-reminder`,
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return null;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { status: 503, message: "Service Unavailable" };
    } else {
      return { status: 500, message: error.message };
    }
  }
};

// Cancel event registration
export const cancelRegistration = async (eventId, registrationId) => {
  try {
    const res = await axiosInstance.patch(
      `/events/${eventId}/registrations/${registrationId}`,
      { status: "cancellation" },
    );
    return res;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { status: 503, message: "Service Unavailable" };
    } else {
      return { status: 500, message: error.message };
    }
  }
};
